module.exports = __webpack_public_path__ + "img/go.b819b1a3.png";